




import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ClientAccount } from '@/shared/clients/client-account';

@Component
export default class DoNotContactWarning extends Vue {
    @Prop({ required: true }) public client!: ClientAccount;
}
